import type { ReactNode } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { WagmiProvider } from "wagmi";
import ErrorBoundary from "@/components/ErrorBoundary";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { wagmiConfig } from "@/config";
import { ThemeProvider } from "@/contexts/ThemeContext";

/**
 * 全局 Provider：错误边界 → 钱包 → React Query → 主题 → Tooltip → 全局 Toast
 */
export function AppProviders({ children }: { children: ReactNode }) {
  const queryClient = new QueryClient({});
  return (
    <ErrorBoundary>
      <WagmiProvider config={wagmiConfig}>
        <QueryClientProvider client={queryClient}>
          <ThemeProvider defaultTheme="dark">
            <TooltipProvider>
              <Toaster visibleToasts={1} expand={false} />
              {children}
            </TooltipProvider>
          </ThemeProvider>
        </QueryClientProvider>
      </WagmiProvider>
    </ErrorBoundary>
  );
}
